<template>
  <div>
    <tabs
      :links="tabList"
      :level="1"
      :mode="'emitter'"
      :current-tab="tab"
      @changeView="tab = $event"
      class="is-border-bottom">
    </tabs>
    <div v-if="tab === 'RDV'">
      <calendar-form
        :from-calendar-date="paramsQuickview.fromCalendarDate"
        :source="paramsQuickview.source"
        :contact-source="paramsQuickview.contact"
        :previous="paramsQuickview.previous"
        ref="innerComponent"></calendar-form>
    </div>
    <div v-else>
      <reminder-form
        :source="paramsQuickview.source"
        :params="paramsQuickview"
        ref="innerComponent"></reminder-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewCalendarAction',
  components: {
    CalendarForm: () => import('@/components/calendar/CalendarForm'),
    ReminderForm: () => import('@/components/calendar/ReminderForm')
  },
  props: {
    paramsQuickview: Object
  },
  data () {
    return {
      tab: 'RDV'
    }
  },
  computed: {
    tabList () {
      let tabs = []
      if ('type' in this.paramsQuickview) {
        if (this.paramsQuickview.type === 'rdv') {
          tabs = [
            { label: `Rendez-vous`, link: 'RDV' },
            { label: `Rappel`, link: 'REMINDER', disable: this.paramsQuickview.disableOtherTab }
          ]
        } else if (this.paramsQuickview.type === 'onlyReminder') {
          tabs = [
            { label: `Rappel`, link: 'REMINDER' }
          ]
        } else {
          tabs = [
            { label: `Rendez-vous`, link: 'RDV', disable: true },
            { label: `Rappel`, link: 'REMINDER' }
          ]
        }
      } else {
        tabs = [
          { label: `Rendez-vous`, link: 'RDV' },
          { label: `Rappel`, link: 'REMINDER' }
        ]
      }
      return tabs
    }
  },
  created () {
    if ('type' in this.paramsQuickview && (this.paramsQuickview.type === 'reminder' || this.paramsQuickview.type === 'onlyReminder')) {
      this.tab = 'REMINDER'
    }
  },
  methods: {
    submitQuickview () {
      if (this.tab === 'RDV') {
        this.$refs.innerComponent.submitRdv()
      } else {
        this.$refs.innerComponent.submitReminder()
      }
    }
  }
}
</script>
